import React from 'react'
import styled, { keyframes } from 'styled-components'

const fadeInModal = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-0.5rem);
  }
  to {
    opacity: 0.95;
    transform: scale(1) translateY(0);
  }
`

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

const ModalContainer = styled.div`
  border-radius: 0.5rem;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem;
  color: white;
  line-height: 1.25rem;
  text-align: center;
  width: 20rem;
  display: flex;
  flex-direction: column;
  position: relative;
  opacity: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  animation: ${fadeInModal} 0.3s ease-out forwards;
`

const ModalTitle = styled.h3`
  margin: 0 0 1.5rem 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: white;
  letter-spacing: 0.025rem;
  opacity: 0.95;
`

type KestrelModalProps = {
  handleClose: () => void
  title: string
  children: React.ReactNode
}

export const KestrelModal: React.FC<KestrelModalProps> = ({
  title,
  handleClose,
  children,
}) => {
  return (
    <ModalBackdrop onClick={handleClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalTitle>{title}</ModalTitle>
        {children}
      </ModalContainer>
    </ModalBackdrop>
  )
}
